// extracted by mini-css-extract-plugin
export default {"modalPlayersList":"j3JrNUPIdYs2zN8UCUmA"};